export function vpsReducer(state, action) {
  switch (action.type) {
    case "SET_CURRENT_PID":
      return {
        ...state,
        pid: action.payload,
      };
    case "SET_PRODUCT_PRICE":
      return {
        ...state,
        price: action.payload,
      };
    case "SET_PRODUCT_DETAIL":
      return {
        ...state,
        vpsDetails: {
          ...state.vpsDetails,
          gid: action.payload.gid,
          pid: action.payload.pid,
          name: action.payload.name,
          type: action.payload.type,
          price: action.payload.price,
          billingcycle: action.payload.billingcycle,
          vpsaddons: [],
        },
      };
    case "SET_PROMO":
      return {
        ...state,
        promo: {
          ...state.promo,
          realprice: action.payload.realprice,
          appliesto: action.payload.appliesto,
          description: action.payload.description,
          price: action.payload.price,
          type: action.payload.type,
          promocode: action.payload.promocode,
          pid: action.payload.pid,
        },
      };
    case "SET_HOSTNAME_PASSWORD":
      return {
        ...state,
        vpsDetails: {
          ...state.vpsDetails,
          hostname: action.payload.hostname,
          password: action.payload.password,
        },
      };
    case "SET_OS":
      return {
        ...state,
        vpsDetails: {
          ...state.vpsDetails,
          vpsaddons: [action.payload.os],
        },
      };
    case "SET_PRICE_WITH_ADDON":
      return {
        ...state,
        vpsDetails: {
          ...state.vpsDetails,
          priceWithAddon: action.payload,
        },
      };
    case "RESET_PRODUCT":
      return {
        ...state,
        vpsDetails: null,
        price: {},
        promo: null,
      };
    default:
      return state;
  }
}
